<template>
  <div>
    <form @submit.prevent="getShippingSearch">
      <div class="row">
        <div class="col-md-12 col-lg-4">
          <label class="form-label" for="startdate">Date From: </label>

          <input
            type="date"
            name="startdate"
            class="form-control"
            v-model="sDate"
            @change="startDate"
          />
        </div>
        <div class="col-md-12 col-lg-4">
          <label class="form-label" for="enddate">Date To: </label>
          <input
            type="date"
            class="form-control"
            name="enddate"
            v-model="eDate"
            @change="endDate"
          />
        </div>
        <div class="col-md-12 col-lg-4">
          <label class="form-label" for="client">Client: </label>
          <select class="form-control" id="client" v-model.number="form.client">
            <option value="1">Taico</option>
            <option value="2">UBS</option>
          </select>
        </div>

        <div class="col-md-12 mt-3">
          <div class="">
            <input type="submit" value="Search" class="btn btn-primary" />
          </div>
        </div>
      </div>
    </form>
    <div v-if="isLoading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>
    <div v-if="showSearch === true">
      <div class="mt-5 table-responsive">
        <table class="table border">
          <thead>
            <tr>
              <th
                scope="col"
                @click="sortOnField('ORDERNUMBER')"
                style="cursor: pointer"
              >
                Order Number
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
              <th
                scope="col"
                @click="sortOnField('FIRSTNAME')"
                style="cursor: pointer"
              >
                Name
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
              <th
                scope="col"
                @click="sortOnField('CLIENTID')"
                style="cursor: pointer"
              >
                Company
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
              <th
                scope="col"
                @click="sortOnField('ORDERDATE')"
                style="cursor: pointer"
              >
                Date Ordered
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
              <th
                scope="col"
                @click="sortOnField('PRODUCTNAME')"
                style="cursor: pointer"
              >
                Product Name
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
              <th
                scope="col"
                @click="sortOnField('SKU')"
                style="cursor: pointer"
              >
                SKU/Prod#
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
              <th
                scope="col"
                @click="sortOnField('PRODUCTCOST')"
                style="cursor: pointer"
              >
                Cost
                <span
                  >&nbsp;<font-awesome-icon
                    icon="sort"
                    class="fa-solid fa-sort sort-color"
                /></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="this.allShippingSearch.Result === null">
              <td colspan="7">
                <p class="text-center">No data available in table</p>
              </td>
            </tr>
            <tr v-if="loading === true">
              <div>
                <div class="centered">
                  <a-spin />
                </div>
              </div>
            </tr>

            <tr
              v-for="order in this.allShippingSearch.Result"
              :key="order.id"
              v-else
            >
              <td>
                <router-link
                  :to="{
                    name: 'OrderDetails',
                    query: {
                      order_id: order.id,
                      order_number: order.order_number,
                    },
                  }"
                  >{{ order.order_number }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'DivvyAdminUsersEditUser',
                    params: {
                      id: order.user_id,
                    },
                  }"
                  >{{ order.first_name }} {{ order.last_name }}</router-link
                >
              </td>

              <td>
                <router-link
                  :to="{
                    name: 'EditClient',
                    params: {
                      Id: order.client_id,
                    },
                  }"
                >
                  {{ order.company_name }}
                </router-link>
              </td>

              <td>
                {{ order.order_date }}
              </td>

              <td>
                {{ order.product_name }}
              </td>

              <td>
                {{ order.sku }}
              </td>

              <td>
                {{ order.product_cost }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between">
          <div>
            <span v-if="allShippingSearch.Result === null"
              >Showing 0 to 0 of 0 entries</span
            >
            <span v-else
              >Showing
              {{ (currentPage - 1) * allShippingSearch.pageSize + 1 }} to
              {{
                (currentPage - 1) * allShippingSearch.pageSize +
                  allShippingSearch.selectedRecordCount
              }}
              of {{ allShippingSearch.totalRecords }} entries</span
            >
          </div>
          <div class="" v-if="allShippingSearch.Result">
            <pagination
              :data="allShippingSearch.Result"
              :totalPages="Math.ceil(allShippingSearch.totalRecords / perPage)"
              :total="allShippingSearch.totalRecords"
              :perPage="perPage"
              :currentPage="currentPage"
              @pagechanged="onPageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import {
  getNowDateYearMonthDay,
  getDate7DaysBefore,
  getMonthDayYear,
} from "@/utilities/date";
export default {
  name: "ShippingSearchForm",
  components: {
    pagination: Pagination,
  },
  data() {
    return {
      form: {
        start_date: "",
        end_date: "",
        client: 1,
      },
      sDate: "",
      eDate: "",
      loading: false,
      currentPage: 1,
      perPage: 10,
      showSearch: false,
      isLoading: false,
      sortField: "ORDERDATE",
      sortOrder: "ASC",
    };
  },
  methods: {
    getShippingSearch() {
      if (!this.form.client || this.form.client === "null") {
        alert("Please select a client");
        this.showSearch = false;
        return;
      }
      this.isLoading = true;
      this.currentPage = 1;
      this.$store
        .dispatch("shippingSearch/fetchShippingSearch", {
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          client: this.form.client,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.isLoading = false;
          this.showSearch = true;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.$store
        .dispatch("shippingSearch/fetchShippingSearch", {
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          client: this.form.client,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    sortOnField(field) {
      this.loading = true;
      this.sortField = field;
      this.sortOrder = this.sortOrder === "ASC" ? "DESC" : "ASC";
      this.$store
        .dispatch("shippingSearch/fetchShippingSearch", {
          start_date: this.form.start_date,
          end_date: this.form.end_date,
          client: this.form.client,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    allShippingSearch() {
      var shippingSearches = this.$store.getters[
        "shippingSearch/allShippingSearch"
      ];

      // updating order_date to mm-dd-yyyy format
      shippingSearches.Result?.forEach((order) => {
        order.order_date = order.order_date
          ? getMonthDayYear(order.order_date.substring(0, 10))
          : "";
      });

      return shippingSearches;
    },
    startDate() {
      if (this.sDate) {
        var jsObj = JSON.parse(JSON.stringify(this.sDate));
        var dt = new Date(jsObj);
        var newDate = dt.toISOString();
        this.form.start_date = newDate;
        return this.form.start_date;
      } else {
        this.form.start_date = "";
        return this.form.start_date;
      }
    },
    endDate() {
      if (this.eDate) {
        var jsObj = JSON.parse(JSON.stringify(this.eDate));
        var dt = new Date(jsObj);
        var newDate = dt.toISOString();
        this.form.end_date = newDate;
        return this.form.end_date;
      } else {
        this.form.end_date = "";
        return this.form.end_date;
      }
    },
    sortOrderClass() {
      return this.sortOrder === "ASC" ? "asc" : "desc";
    },
  },
  mounted() {
    if (this.allShippingSearch.Result) {
      this.showSearch = true;
    } else {
      this.showSearch = false;
    }
  },
  created() {
    this.sDate = getDate7DaysBefore();
    this.eDate = getNowDateYearMonthDay();
  },
};
</script>
<style lang="scss" scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
}

.centered {
  position: fixed;
  top: 62%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}

.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.sort-color {
  color: rgb(34, 177, 253);
}
</style>
